import { render, staticRenderFns } from "./StepPriceForm.vue?vue&type=template&id=19aaf5b7&scoped=true&"
import script from "./StepPriceForm.vue?vue&type=script&lang=js&"
export * from "./StepPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./StepPriceForm.vue?vue&type=style&index=0&id=19aaf5b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aaf5b7",
  null
  
)

export default component.exports